import * as BABYLON from "babylonjs";
import { AccelerationCurve } from "../core/accelerationCurve";
import { VectorUtils } from "../core/vectorUtils";
import { EarthEngine, FrameTime } from "../earthEngine";

export class CameraTransition {
    private _from: BABYLON.Vector3;
    private _to: BABYLON.Vector3;
    private _ratio: number;
    private _duration: number;
    private _acceleration: AccelerationCurve;
    private _position: BABYLON.Vector3;

    constructor(from: BABYLON.Vector3, to: BABYLON.Vector3, duration: number, acceleration: AccelerationCurve) {
        this._from = from.clone();
        this._to = to.clone();
        this._ratio = 0;
        this._duration = duration;
        this._acceleration = acceleration;
        this._position = from.clone();
    }

    get position(): BABYLON.Vector3 {
        return this._position;
    }

    get isRunning(): boolean {
        return (this._ratio < 1.0);
    }

    update(time: FrameTime) {
        //  *** Update Time
        this._ratio = Math.min(this._ratio + time.deltaTime / this._duration, 1.0);

        //  *** Take acceleration into accout
        let realRatio = this._acceleration.getValue(this._ratio);

        //  *** compute Position
        this._position = VectorUtils.slerp(this._from, this._to, realRatio);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/display/cameraTransition.ts